import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class IntercomService {
  fetchConversations({ email, perPage, startingAfter }) {
    const params = { email, perPage, ...(startingAfter && { startingAfter }) };
    return securedAxiosInstance.get("/intercom/conversations", {
      params: toSnakeCase(params),
    });
  }

  fetchConversation(id) {
    return securedAxiosInstance.get(`/intercom/conversations/${id}`);
  }
}

export default new IntercomService();
